import React from "react";

const Blog = () => {
  return (
    <div className="grid lg:grid-cols-2 gap-4 mb-10">
      <div className=" mx-auto shadow-xl my-5 p-5 border border-firstColor rounded-md">
        <h2 className="text-2xl font-bold">
          Difference between SQL and NoSQL?
        </h2>
        <p className="text-xl">
          <span className="text-2xl font-semibold">Ans: </span>
          SQL is the programming language used to interface with relational
          databases. (Relational databases model data as records in rows and
          tables with logical links between them). NoSQL is a class of DBMs that
          are non-relational and generally do not use SQL.
        </p>
      </div>
      <div className=" mx-auto shadow-xl my-5 p-5 border border-firstColor rounded-md">
        <h2 className="text-2xl font-bold">
          Difference between SQL and NoSQL?
        </h2>
        <p className="text-xl">
          <span className="text-2xl font-semibold">Ans: </span>
          SQL is the programming language used to interface with relational
          databases. (Relational databases model data as records in rows and
          tables with logical links between them). NoSQL is a class of DBMs that
          are non-relational and generally do not use SQL.
        </p>
      </div>
      <div className=" mx-auto shadow-xl my-5 p-5 border border-firstColor rounded-md">
        <h2 className="text-2xl font-bold">
          Difference between SQL and NoSQL?
        </h2>
        <p className="text-xl">
          <span className="text-2xl font-semibold">Ans: </span>
          SQL is the programming language used to interface with relational
          databases. (Relational databases model data as records in rows and
          tables with logical links between them). NoSQL is a class of DBMs that
          are non-relational and generally do not use SQL.
        </p>
      </div>
      <div className=" mx-auto shadow-xl my-5 p-5 border border-firstColor rounded-md">
        <h2 className="text-2xl font-bold">
          Difference between SQL and NoSQL?
        </h2>
        <p className="text-xl">
          <span className="text-2xl font-semibold">Ans: </span>
          SQL is the programming language used to interface with relational
          databases. (Relational databases model data as records in rows and
          tables with logical links between them). NoSQL is a class of DBMs that
          are non-relational and generally do not use SQL.
        </p>
      </div>
    </div>
  );
};

export default Blog;
